import React from "react";
import PropTypes from "prop-types";

function ProcessesFieldset({ children }) {
  return (
    <fieldset style={{ border: "none", padding: "0" }}>
      <legend style={{ fontWeight: "bold", marginBottom: "0.5em" }}>
        Processes
        <span style={{ color: "#BF3333" }}>*</span>
      </legend>

      {children}
    </fieldset>
  );
}

ProcessesFieldset.propTypes = {
  children: PropTypes.node.isRequired,
};

ProcessesFieldset.defaultProps = {};

export default ProcessesFieldset;
